import { css } from '@emotion/css';
import { RootState, useAppSelector } from 'cache/store';
import alertMsg from 'components/alert-message/alert-message';
import LiveCasinoSection from 'components/live-casino/LiveCasinoSection';
import Modal from 'components/modal/Modal';
import FastTransferGame from 'components/transfer/FastTransferGame';
import globalStyle from 'constants/global.style';
import { colors } from 'constants/theme';
import { Game3rdMenuItem, MenuHeaderItem } from 'models/commonModel';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import bgsport from 'assets/images/bg/bg-sport.png';

function LobbyPage() {
    const { menuGame } = useAppSelector((state: RootState) => state.system);
    const { isLogged } = useAppSelector((state: RootState) => state.auth);
    const [searchParams] = useSearchParams();
    const type: string = searchParams.get('type') || 'LC'; //mặc định live casino
    const [lobbyActive, setLobbyActive] = useState<MenuHeaderItem>({} as MenuHeaderItem);
    const [gameTransferSelect, setGameTransferSelect] = useState<Game3rdMenuItem | null>(null);

    useEffect(() => {
        if (menuGame.length > 0) {
            let lobby = menuGame.filter((game) => game.child).find((item) => item.gametype === type);
            if (!lobby) {
                lobby = menuGame[0];
            }
            setLobbyActive(lobby);
        }
    }, [type, menuGame]);

    const selectGame = (game: Game3rdMenuItem) => {
        if (!isLogged) {
            alertMsg('Vui lòng đăng nhập');
            return;
        }
        setGameTransferSelect(game);
    };

    return (
        <>
            <div className={styles.wrap}>
                <div className={styles.bannerImg}>
                    <div className={styles.titleGame}>
                        <h6>{lobbyActive.name}</h6>
                    </div>
                </div>
                <div className={styles.gameContent}>
                    <div className={globalStyle.container}>
                        {lobbyActive.child && lobbyActive.gametype && <LiveCasinoSection gametype={lobbyActive.gametype} gameList={lobbyActive.child} onSelect={selectGame} />}
                    </div>
                </div>
            </div>
            {/* popup chuyển quỹ nhanh */}
            <Modal isShow={Boolean(gameTransferSelect)} onClose={() => setGameTransferSelect(null)} width="520px">
                {gameTransferSelect ? <FastTransferGame gameData={gameTransferSelect} onClose={() => setGameTransferSelect(null)} /> : <></>}
            </Modal>
        </>
    );
}

const styles = {
    wrap: css``,
    bannerImg: css`
        background: url(${bgsport}) center center no-repeat;
        background-size: 100% 100%;
        width: 100%;
        img {
            width: 100%;
        }
    `,
    titleGame: css`
        padding: 50px;
        h6 {
            font-size: 36px;
            color: ${colors.white};
            text-align: center;
            text-transform: uppercase;
        }
    `,
    gameContent: css`
        margin: 24px 0;
    `,
};

export default LobbyPage;
